import React, { useEffect, useState } from "react";
import { Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { disabledAnalysisWhen, getAvailableAnalysis, getMarketPackageCode, getModuleCode, getPackageObj } from "../../../../utils/oneintelligence/OneIntelligenceHelper"
import { setFreeFormTypeToAdd, setFullMarketTypeToAdd, setMarketCategoryTypeToAdd, setQuickReportTypeToAdd } from "../../../../store/components/Reports.slice"
import { setCurrentSelectedMode, setReportBuilderMode } from "../../../../store/components/ReportBuilder.slice"
import { getAnalysisDescription, getAnalysisImage, getAnalysisName, getAnalysisSubTitle, getAnalysisTitle } from "../../../../utils/analysis/AnalysisHelper"

function AnalaysisSelect({
    showQuickReport,
    showBehavioralSegment,
    showWhitespacesSelection,
    showFreeForm
}) {
    const dispatch = useDispatch();
    const [isDisabled, setisDisabled] = useState(true);
    const { configuration: { buildedTargets } } = useSelector((state) => state.marketExplorer);
    const { setup } = useSelector((state) => state.buildTargets);

    useEffect(() => {
        setisDisabled(disabledAnalysisWhen());
    }, [buildedTargets, setup]);

    const analysisList = getAvailableAnalysis(isDisabled);

    const packageObj = getPackageObj();
    const marketPackageCode = getMarketPackageCode();

    return (
        <div className="analaysis-select">
            <div
                className="analaysis-select_content"
                style={{
                    justifyContent: analysisList.length <= 3 ? "center" : "start"
                }}
            >
                <div className="analaysis-select_title">{getAnalysisTitle()}</div>
                <div className="analaysis-select_description">
                    {getAnalysisSubTitle()}
                </div>
                <Radio.Group className="analaysis-select_section">
                    {analysisList.map((type) => {
                        const { disabledItem, notAvailable } = type;
                        const code = packageObj?.code?.replace("dev", "");
                        return (
                            <Radio
                                key={type.key}
                                value={type.key}
                                className={`analaysis-select_section_item${disabledItem ? " disabled" : ""}`}
                                disabled={disabledItem}
                            >
                                <div
                                    className="analaysis-select_section_item_card"
                                    onClick={async () => {
                                        if (disabledItem) return;
                                        await dispatch(setCurrentSelectedMode(type.key))
                                        if (type.key === "singlecategory") {
                                            dispatch(setQuickReportTypeToAdd("new"));
                                            showQuickReport(true);
                                        } else if (["marketcategory", "hcpattributes", "hcpmarketscan", "petientmarketscan",
                                            "tiktokhastags", "analysis_gdn&trv_affinity",
                                            "analysis_gdn&trv_purchase",
                                            "analysis_gdn&trv_topic",
                                            "yahoo_audiences_attribute_targeting",
                                            "yahoo_audiences_interests",
                                            "yahoo_audiences_purchase_intent_targeting",
                                            "tiktokinterest",
                                            "tiktokvideointeractions",
                                            "purchaseintentions",
                                            "icd10clinicalmodification",
                                            "icd10procedurecodingsystem",
                                            "tiktokcreatorinteractions",
                                            "la_demographicsattributes",
                                            "la_behavioralattributes",
                                            "la_purchaseintent",
                                            "la_hobbiesinterests",
                                            "medicaljournal",
                                            "medicalassociations",
                                            "medicalwebsites",
                                            "medicalconferences",
                                            "mokb_analysis",
                                            "continuingmedicaleducation"].includes(type.key)) {
                                            if (marketPackageCode === "whitespaces" && "mokb_analysis" === type.key) {
                                                showWhitespacesSelection({
                                                    show: true,
                                                    isInclude: false,
                                                    analysis: type.key
                                                });
                                            } else {
                                                dispatch(setMarketCategoryTypeToAdd("new"));
                                                showBehavioralSegment(true);
                                            }
                                        } else if (["candidatewhitespaces",
                                            "analysis_politicaltaxonomy",
                                            "usersearchjourney",
                                            "otherwhitespaces",
                                            "claimswhitespaces",
                                            "ingredientshitespaces",
                                            "safetycocernsideeffectswhitespaces",
                                            "macrowhitespaces",
                                            "standardtreatmentjourney",
                                            "othermacrowhitespaces",
                                            "symptomswhitespaces",
                                            "diagnosistreatmentwhitespaces"].includes(type.key)) {
                                            let isInclude = true;
                                            if (type.key === "otherwhitespaces" || type.key === "othermacrowhitespaces") {
                                                isInclude = false;
                                            }
                                            showWhitespacesSelection({
                                                show: true,
                                                isInclude,
                                                analysis: type.key
                                            });
                                        } else if (type.key === "freeform") {
                                            dispatch(setFreeFormTypeToAdd("new"));
                                            showFreeForm(true);
                                        } else {
                                            dispatch(setFullMarketTypeToAdd("new"));
                                            dispatch(setReportBuilderMode(type.key));
                                        }
                                    }}
                                >
                                    <div className="analaysis-select_section_item_imgcont">
                                        <img src={getAnalysisImage(type.key, disabledItem)} alt="logo" />
                                    </div>
                                    <div className="flex-1 d-flex-col justify-content-center">
                                        {notAvailable && (
                                            <span style={{
                                                position: "absolute",
                                                right: "5mm",
                                                top: "2mm",
                                                fontWeight: 600
                                            }}
                                            >
                                                Available Soon
                                            </span>
                                        )}
                                        <div className="title">{getAnalysisName(type, code)}</div>
                                        <div className="description">{getAnalysisDescription(type, code)}</div>
                                    </div>
                                </div>
                            </Radio>
                        );
                    })}
                </Radio.Group>
            </div>
        </div>
    );
}

export default AnalaysisSelect;
